/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { getColor } from 'utils';
import styled, { withTheme } from 'styled-components';

const ScreenshotSVG = styled('svg')`
  color: ${props => props.color || getColor(props, 'onPrimary')};
`;

const ScreenshotOutlined = withTheme(props => {
  const { theme, width, height, color } = props;
  const appStore = useSelector(state => state.app);
  const selectedTheme = appStore.theme;

  return (
    <ScreenshotSVG
      theme={theme}
      $selectedTheme={selectedTheme}
      width={width || 32}
      height={height || 32}
      color={color}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path fill='currentColor' d='m14.12 4l1.83 2H20v12H4V6h4.05l1.83-2h4.24M15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm-3 7c1.65 0 3 1.35 3 3s-1.35 3-3 3s-3-1.35-3-3s1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5z' />
    </ScreenshotSVG>
  );
});

export { ScreenshotOutlined };